import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "relieve",
  "use": "relieve-usage",
  "viewBox": "0 0 90.61 99.9",
  "content": "<symbol viewBox=\"0 0 90.61 99.9\" id=\"relieve\"><title>relieve</title><path d=\"M133.3,59.4H120.8A12.09,12.09,0,0,0,109.1,50H90.9a12.26,12.26,0,0,0-11.7,9.4H66.7A12.3,12.3,0,0,0,54.6,71.9V75h3v3.1h6v59.3a12.3,12.3,0,0,0,12.1,12.5h48.4a12.3,12.3,0,0,0,12.1-12.5V78.2h6V75h3V71.9A12.07,12.07,0,0,0,133.3,59.4ZM90.9,56.3h18.2a6.06,6.06,0,0,1,5.2,3.1H85.7A6.19,6.19,0,0,1,90.9,56.3Zm39.3,81.1a6.13,6.13,0,0,1-6,6.2H75.8a6.57,6.57,0,0,1-6.5-6.2l.4-59.3h60.5v59.3Zm1.9-65.5H60.7a6.15,6.15,0,0,1,6.1-6.2h66.5a6.13,6.13,0,0,1,6,6.2Z\" transform=\"translate(-54.6 -50)\" /><path d=\"M98.1,110c5.5,0,17.1,2.6,17.1,10.2,0,6.8.4,9.4-1.7,15.4,5.5-6,8.9-12.4,8.9-19.2,0-16.6-20.5-20-24.3-20V86.1L76.8,104l21.3,17.1Z\" transform=\"translate(-54.6 -50)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/relieve.svg
// module id = aVl7
// module chunks = 264